import Prismic from "prismic-javascript";
export default Prismic.api.bind(
	null,
	"https://bibleforlife.cdn.prismic.io/api/v2"
);
